import { useCallback, useEffect, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { api } from "../../../../services/api";
import Loading from "../../../../components/Loading";
import "./eventopublic.css";
import HeaderPublic from "./HeaderPublic";
import DrawerPublic from "./drawer/first-drawer/FirstDrawerMobile";
import PrivateEvent from "../../../../components/ProtectedRoutes/PrivateEvent";
import { useMediaQuery } from "react-responsive";
import { ContentDesktop } from "./contenido/desktop/ContentDesktop";
import ContentMobile from "./contenido/mobile/ContentMobile";
import FirstDrawerDesktop from "./drawer/first-drawer/FirstDrawerDesktop";
import { Box, Paper, Typography } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import PublicDisponibilidadModal from "../../../../components/modales/ubicaciones/PublicDisponibilidadModal";

export const EventoPublic = () => {
	const history = useHistory();
	const location = useLocation();
	const [data, setData] = useState();
	const [isPrivated, setIsPrivated] = useState();
	const [asientosSeleccionados, setAsientosSeleccionados] = useState({});
	const param = useParams();
	const eventoId = param.id;
	const [cantidad, setCantidad] = useState({});
	const [showResume, setShowResume] = useState(false);
	const [openDrawer, setOpenDrawer] = useState(false);
	const [tarifasSeleccionadas, setTarifasSeleccionadas] = useState([]);
	const [mpVinculado, setMpVinculado] = useState();
	const isMobile = useMediaQuery({ query: `(max-width: 770px)` });

	const callApi = useCallback(async () => {
		try {
			const response = await api.eventos.getPublic(eventoId);
			if (response.status === "success") {
				const eventoData = {
					...response.data.evento,
					medios_pago: response.data.medios_pago
				};
				/* console.log("reddspooasdjas", data); */
				setData(eventoData);
				setIsPrivated(response.data.evento.privado)

				// google analytics 
				// seccion de acuerdo a la ruta
				const isSlugRoute = location.pathname.startsWith('/e/');
				const seccion = isSlugRoute ?
					location.pathname.split('/')[2] : //slug amigable
					`evento-${eventoId}`; //formato de ruta general /evento/id/informacion

				if (window.gtag) {
					window.gtag('event', 'Eventos', {
						seccion: seccion,
						timestamp: new Date().toISOString()
					});
				}
			} else {
				history.push('/');
				return;
			}


		} catch (error) {
			console.error = () => { };
			history.push('/');
		}
	}, [eventoId, location.pathname]);

	useEffect(() => {
		callApi()
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [callApi, history]);


	const hoy = new Date();

	const tarifasTicketsFiltrados = data?.tarifas?.filter((tarifa) => {
		const inicioVenta = new Date(tarifa.inicio_venta);
		const finVenta = new Date(tarifa.fin_venta);

		return (
			tarifa.idtipo === 1 &&
			inicioVenta <= hoy &&
			hoy <= finVenta &&
			tarifa.privado === false
		);
	});

	const tarifasVouchersFiltrados = data?.tarifas?.filter((tarifa) => {
		const inicioVenta = new Date(tarifa.inicio_venta);
		const finVenta = new Date(tarifa.fin_venta);

		return (
			tarifa.idtipo === 2 &&
			inicioVenta <= hoy &&
			hoy <= finVenta &&
			tarifa.privado === false
		);
	});

	const toggleDrawer = (newOpenDrawer) => () => {
		setOpenDrawer(newOpenDrawer);
		setShowResume(false);
	};

	const [openMapaModal, setOpenMapaModal] = useState(false);

	// si o si visionario
	const esEventoVisionario = data?.id === 461;

	const zonaVisionario = {
		id: 468,
		ubicacion: "Vizenzo"
	};

	const abrirMapa = () => {
		setOpenMapaModal(true);
	};

	if (!data) {
		return <Loading />;
	}

	return (
		<>
			{isPrivated ? (
				<PrivateEvent />
			) : (
				<>
					<HeaderPublic data={data} />

					{isMobile ?
						<ContentMobile data={data} />
						:
						<ContentDesktop
							data={data}
							cantidad={cantidad}
							toggleDrawer={toggleDrawer}
							setCantidad={setCantidad}
							asientosSeleccionados={asientosSeleccionados}
							setAsientosSeleccionados={setAsientosSeleccionados}
							tarifasTicketsFiltrados={tarifasTicketsFiltrados}
							tarifasVouchersFiltrados={tarifasVouchersFiltrados}
							setTarifasSeleccionadas={setTarifasSeleccionadas} />
					}

					{esEventoVisionario && isMobile && (
						<>
							<Paper elevation={8} sx={{
								position: 'fixed',
								bottom: 0,
								left: 0,
								right: 0,
								zIndex: 1300,
								background: 'white',
								padding: '12px 16px',
								borderRadius: '20px 20px 0 0',
								boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.15)',
								cursor: 'pointer',
								transition: 'all 0.3s ease',
								'&:hover': {
									transform: 'translateY(-2px)',
									boxShadow: '0 -6px 25px rgba(0, 0, 0, 0.2)',
								}
							}}
								onClick={abrirMapa}
							>
								<Box sx={{
									p: 2,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									borderRadius: '10px',
									gap: 2,
									color: 'white',
									backgroundColor: "#5656ff",
								}}>

									<Visibility sx={{ fontSize: 28 }} />

									<Box sx={{ textAlign: 'center' }}>
										<Typography variant="h6" sx={{
											fontWeight: 700,
											fontSize: '18px',
										}}>
											Ver mapa del evento
										</Typography>
									</Box>
								</Box>
							</Paper>

						</>
					)}
					<PublicDisponibilidadModal
						open={openMapaModal}
						onClose={() => setOpenMapaModal(false)}
						zona={zonaVisionario}
					/>
					{(tarifasTicketsFiltrados?.length > 0 || tarifasVouchersFiltrados?.length > 0) && (
						<>
							{isMobile ?
								<DrawerPublic
									data={data}
									cantidad={cantidad}
									toggleDrawer={toggleDrawer}
									openDrawer={openDrawer}
									setCantidad={setCantidad}
									asientosSeleccionados={asientosSeleccionados}
									setAsientosSeleccionados={setAsientosSeleccionados}
									mpVinculado={mpVinculado}
									tarifasTicketsFiltrados={tarifasTicketsFiltrados}
									tarifasVouchersFiltrados={tarifasVouchersFiltrados}
									tarifasSeleccionadas={tarifasSeleccionadas}
									setTarifasSeleccionadas={setTarifasSeleccionadas}
								/>
								:
								<FirstDrawerDesktop
									data={data}
									cantidad={cantidad}
									toggleDrawer={toggleDrawer}
									openDrawer={openDrawer}
									setCantidad={setCantidad}
									asientosSeleccionados={asientosSeleccionados}
									setAsientosSeleccionados={setAsientosSeleccionados}
									mpVinculado={mpVinculado}
									tarifasTicketsFiltrados={tarifasTicketsFiltrados}
									tarifasVouchersFiltrados={tarifasVouchersFiltrados}
									tarifasSeleccionadas={tarifasSeleccionadas}
									setTarifasSeleccionadas={setTarifasSeleccionadas} />
							}
						</>
					)}
				</>
			)}
		</>
	);

};
